import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { Button } from "antd";
import { ClearOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import SignaturePad from "../workReports/SignaturePad";
import "./signature.css";

/**
 * The work-report signature pad in a framed box with a hint and a clear button. The ref exposes
 * isEmpty(), clear() and toDataURL() like the pad itself.
 */
const SignatureField = forwardRef(({ label }, ref) => {
  const { t } = useTranslation("dashboard");
  const pad = useRef(null);
  const [hasInk, setHasInk] = useState(false);

  useImperativeHandle(ref, () => ({
    isEmpty: () => !pad.current || pad.current.isEmpty(),
    clear: () => pad.current?.clear(),
    toDataURL: () => pad.current?.toDataURL() || ""
  }));

  return (
    <div className="sf-signature">
      {label && <div className="sf-signature-label">{label}</div>}
      <div className="sf-signature-box">
        <SignaturePad ref={pad} onChange={setHasInk} ariaLabel={label || t("Signature")} />
        <span className="sf-signature-hint" aria-hidden="true">
          {hasInk ? "" : t("Sign here")}
        </span>
        <Button
          className="sf-signature-clear"
          size="small"
          icon={<ClearOutlined />}
          onClick={() => pad.current?.clear()}
        >
          {t("Clear")}
        </Button>
      </div>
    </div>
  );
});

SignatureField.displayName = "SignatureField";

export default SignatureField;
